import { useCallback } from "react";
import { t } from "ttag";

import { Modal } from "metabase/ui";
import type { Dashboard } from "metabase-types/api";

import type { CreateDashboardFormOwnProps } from "./CreateDashboardForm";
import SaveDashboardViewForm from "./SaveDashboardViewForm";

interface SaveDashboardViewModalProps
  extends Omit<CreateDashboardFormOwnProps, "onCancel"> {
  onClose: () => void;
}

export function SaveDashboardViewModal({
  onCreate,
  onClose,
  ...props
}: SaveDashboardViewModalProps) {
  const handleCreate = useCallback(
    (dashboard: Dashboard) => {
      if (typeof onCreate === "function") {
        onCreate(dashboard);
      } else {
        onClose?.();
      }
    },
    [onCreate, onClose],
  );

  return (
    <Modal.Root opened onClose={onClose} size="lg">
      <Modal.Overlay />
      <Modal.Content p="md">
        <Modal.Header>
          <Modal.Title>{t`Save Current Dashboard View`}</Modal.Title>
          <Modal.CloseButton onClick={onClose} />
        </Modal.Header>
        <Modal.Body>
          <SaveDashboardViewForm
            {...props}
            onClose={onClose}
            onCreate={handleCreate}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
}

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default SaveDashboardViewModal;
